import { api } from "./client";

export type ContactTier = "important" | "normal" | "unimportant";

export type Contact = {
  id: string;
  email: string;
  name: string | null;
  tier: ContactTier;
  createdAt: string;
};

export function listContacts(
  tier: "all" | ContactTier = "all",
  q?: string,
): Promise<{ contacts: Contact[] }> {
  const params = new URLSearchParams({ tier });
  if (q) params.set("q", q);
  return api(`/contacts?${params}`);
}

export function setContactTier(
  id: string,
  tier: ContactTier,
): Promise<{ contact: Contact }> {
  return api(`/contacts/${id}/tier`, { method: "PATCH", body: { tier } });
}

export type ImportResult = {
  emails: string[];
  added: number;
  existing: number;
  contactIds: string[];
};

export function importContacts(input: {
  text?: string;
  imageBase64?: string;
  imageMime?: string;
}): Promise<ImportResult> {
  return api(`/contacts/import`, { method: "POST", body: input });
}
